<template>
  <div id="data-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="ToolIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Maintenance Information</span>
        </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">
            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Location" v-model="data_local.location" type="text" v-validate="'required'" name="location"/>
              <span class="text-danger text-sm"  v-show="errors.has('location')">{{ errors.first('location') }}</span>
            </div> 

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Title" v-model="data_local.title" type="title" v-validate="'required'" name="title" />
              <span class="text-danger text-sm"  v-show="errors.has('title')">{{ errors.first('title') }}</span>
            </div> 

            <div class="mt-4">
              <vs-textarea height="100px" label="Description" class="w-full" v-model="data_local.description" type="text" v-validate="'required'" name="description" />
              <span class="text-danger text-sm"  v-show="errors.has('description')">{{ errors.first('description') }}</span>
            </div>             

            <!-- Col Content -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- uploading docs -->
                <label class="text-sm pl-2">Files</label>
                <div class="flex items-start flex-col sm:flex-row">
                  <div v-if="files.length > 0" v-for="(item, file) in files">
                    <feather-icon icon="XCircleIcon" svgClasses="h-6 w-6" style="top: 12px;left: 82px;color: #ea5455;" class="cursor-pointer" @click="deleteImage(fileKey[file], file)"/>
                    <img :src="item" class="mt-4 mr-8 rounded h-24 w-24" />  
                  </div>
                  <p v-if="files.length ==0" class="text-sm pl-2">No files uploaded</p>
                </div>

                <div class="flex items-start flex-col sm:flex-row">
                  <!-- <vs-avatar :src="data_localavatar" size="80px" class="mr-4" /> -->
                  <!-- uploading docs -->
                  <div class="mt-4">            
                    <input type="file" multiple="multiple" id="fileD" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">

                    <vs-button color="success" class="mr-4" @click="$refs.update_avatar_input.click()">Upload Files</vs-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4">
              <label class="text-sm pl-2">Availability</label>
              <vs-textarea height="100px" label="" class="w-full" v-model="data_local.availability" type="text" name="availability" />
              <span class="text-danger text-sm"  v-show="errors.has('availability')">{{ errors.first('availability') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/2 mt-4" v-if="roleVal == 'admin'">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="Edit3Icon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Maintenance Other Information</span>
        </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">
            <!-- <div class="mt-4">
              <label class="vs-input--label">Type</label>
              <v-select :options="optionType" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.rfp_type" name="rfp_type"/>
              <span class="text-danger text-sm"  v-show="errors.has('rfp_type')">{{ errors.first('rfp_type') }}</span> 
            </div> -->

            <!-- <div class="mt-4">
              <vs-input class="w-full mt-4" label="Request No" v-model="data_local.request_no" type="request_no" v-validate="'required'" name="request_no" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('request_no')">{{ errors.first('request_no') }}</span>
            </div>  -->

            <!-- <div class="mt-4">
              <vs-input class="w-full mt-4" label="Status" v-model="data_local.m_request_status.name" type="text" v-validate="'required'" name="m_request_status" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('m_request_status')">{{ errors.first('m_request_status') }}</span>
            </div> -->

            <div class="mt-4">
              <label class="text-sm pl-2">Manager's Note</label>
              <vs-textarea class="w-full" height="100px" label="" v-model="data_local.notes" v-validate="'required'" name="notes" />
              <span class="text-danger text-sm"  v-show="errors.has('notes')">{{ errors.first('notes') }}</span>
            </div> 

           <!--  <div class="mt-4">
              <vs-input class="w-full mt-4" label="Request By" v-model="data_local.user.full_name" type="text" v-validate="'required'" name="full_name" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('full_name')">{{ errors.first('full_name') }}</span>
            </div>  -->

            <!-- <div class="mt-4">
              <vs-input class="w-full mt-4" label="Received By" v-model="request_to[0]['full_name']" type="text" v-validate="'required'" name="request_to" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('request_to')">{{ errors.first('request_to') }}</span>
            </div>  -->

            <!-- <div class="mt-4">
              <vs-input class="w-full mt-4" label="Date Created" v-model="data_local.createdAt" v-validate="'required'" name="createdAt" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('createdAt')">{{ errors.first('createdAt') }}</span>
            </div> -->  

          </div>
        </div>
      </div> 
    </div>

    <!-- Content Row -->
    <div class="vx-row" v-if="data_local.rfp_type === 2">
      <div class="vx-col w-full md:w-1/2 mt-6">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="PaperclipIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Request Details</span>
        </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">

            <!-- <div class="mt-4">
              <vs-input class="w-full mt-4" label="Property Name" v-model="data_local.property.name" type="text" v-validate="'required'" name="property_id" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('property_id')">{{ errors.first('property_id') }}</span>
            </div>  -->

            <!-- <div class="mt-4" v-if="data_local.issued_by_id !== null">
              <vs-input class="w-full mt-4" label="Issued By" v-model="issued_by[0]['full_name']" type="text" v-validate="'required'" name="issued_by" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('issued_by')">{{ errors.first('issued_by') }}</span> 
            </div>

            <div class="mt-4" v-if="data_local.issued_by_id === null">
              <vs-input class="w-full mt-4" label="Issued By" v-model="data_local.issued_by_id" type="text" v-validate="'required'" name="issued_by_id" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('issued_by_id')">{{ errors.first('issued_by_id') }}</span> 
            </div> -->

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Scope" v-model="data_local.scope" type="text" v-validate="'required'" name="scope" />
              <span class="text-danger text-sm"  v-show="errors.has('scope')">{{ errors.first('scope') }}</span>
            </div> 

            <div class="mt-6 d-inline">
              <label class="vs-input--label" v-if="qs.length == 0">No Questions To Show</label>
              <label class="vs-input--label" v-if="qs.length != 0">Questions</label><br>
              <div class="dt-available mt-2" v-for="(v, key) in qs">
                <div class="vx-row">
                  <div class="vx-col pr-0" style="width:40%">
                    <vs-textarea height="80px" :class="{'w-full':true, 'vs-t-cna':roleVal !== 'admin'}" label="Questions" v-model="v.question" type="text" v-validate="'required'" name="v-question" :disabled="roleVal !== 'admin'"/>
                  </div>
                  <div class="vx-col pr-0" style="width:40%">
                    <vs-textarea height="80px" class="w-full" label="Response" v-model="v.response" type="text" v-validate="'required'" name="v-response" />
                  </div>
                  <div class="vx-col" style="width:10%">
                    <feather-icon icon="XCircleIcon" svgClasses="h-6 w-6" style="top: 40px;left: 10px;color: #ea5455;" class="cursor-pointer w-full" @click="deleteQ(key)"/>
                  </div>
                </div>
              </div>

              <div class="">          
                <vs-button color="success" class="mr-4" @click="addQ">Add Question</vs-button>
              </div>                 
            </div>

            <hr class="mt-6">
            <div class="mt-6 d-inline">
              <label class="vs-input--label" v-if="qts.length == 0">No Quotes to Show</label>
              <label class="vs-input--label" v-if="qts.length != 0">Quotes</label><br>
              <div class="dt-available" v-if="qts.length != 0">
                <div class="vx-row">
                  <div class="vx-col pr-0 m-auto ml-0 mr-0" style="width:60%">
                    <label class="vs-input--label">Description</label>
                  </div>
                  <div class="vx-col pr-0" style="width:10%">
                    <label class="vs-input--label">Quantity / Hrs</label>
                  </div>
                  <div class="vx-col pr-0" style="width:10%">
                    <label class="vs-input--label">Amount per Qty</label>
                  </div>
                  <div class="vx-col pr-0" style="width:10%">
                    <label class="vs-input--label">Total Amount</label>
                  </div>
                </div>
              </div>
              <div class="dt-available mb-4" v-for="(v, key) in qts">
                <div class="vx-row mt-2">
                  <div class="vx-col pr-0" style="width:60%">
                    <vs-input :class="{'w-full':true, 'vs-t-cna':roleVal !== 'admin'}" label="" type="text" v-validate="'required'" name="v.description" v-model="v.description" :disabled="roleVal !== 'admin'"/>
                  </div>
                  <div class="vx-col pr-0" style="width:10%">
                    <vs-input :class="{'w-full':true, 'vs-t-cna':roleVal !== 'admin'}" label="" type="text" v-validate="'required'" name="v.quantity" v-model="v.quantity" :disabled="roleVal !== 'admin'"/>
                  </div>
                  <div class="vx-col pr-0" style="width:10%">
                    <vs-input :class="{'w-full':true, 'vs-t-cna':roleVal !== 'admin'}" label="" type="text" v-validate="'required'" name="v.sub_amount" v-model="v.sub_amount" :disabled="roleVal !== 'admin'"/>
                  </div>
                  <div class="vx-col pr-0" style="width:10%">
                    <vs-input :class="{'w-full':true, 'vs-t-cna':roleVal !== 'admin'}" label="" type="text" v-validate="'required'" name="v.total_amount" v-model="v.total_amount" :disabled="roleVal !== 'admin'"/>
                  </div>
                  <div class="vx-col" style="width:10%">
                    <feather-icon icon="XCircleIcon" svgClasses="h-6 w-6" style="top: 7px;left: 10px;color: #ea5455;" class="cursor-pointer w-full" @click="deleteQT(key)"/>
                  </div>
                </div>
              </div>

              <div class="">          
                <vs-button color="success" class="mr-4" @click="addQT">Add Quote</vs-button>
              </div>                 
            </div>

            <div class="vx-row" v-if="roleVal == 'admin'">
              <div class="vx-col w-full mt-5">
                  <label class="text-sm">Recipients</label>
                  <div class="flex flex-wrap mt-2" @click="clearSelectAssign()">
                    <vs-radio v-model="data_local.assigned_to_type" vs-value="1" value="1" class="mr-4">Staff</vs-radio >
                    <vs-radio v-model="data_local.assigned_to_type" vs-value="2" value="2" class="mr-4">Vendor</vs-radio >
                    <vs-radio v-model="data_local.assigned_to_type" vs-value="3" value="3" class="mr-4">No Action</vs-radio >
                  </div>
              </div>
            </div>

            <div class="mt-4" v-if="data_local.assigned_to_type == 1">          
              <v-select multiple :closeOnSelect="true" :options="optionStaff" :reduce="email => email.id" label="email" v-validate="'required'" v-model="data_local.rfp_recipients" name="rfp_recipients"/>
              <span class="text-danger text-sm"  v-show="errors.has('rfp_recipients')">{{ errors.first('rfp_recipients') }}</span>
            </div>

            <div class="mt-4" v-if="data_local.assigned_to_type == 2">          
              <v-select multiple :closeOnSelect="true" :options="optionVendor" :reduce="business_name => business_name.id" label="business_name" v-validate="'required'" v-model="data_local.rfp_recipients" name="rfp_recipients"/>
              <span class="text-danger text-sm"  v-show="errors.has('rfp_recipients')">{{ errors.first('rfp_recipients') }}</span>
            </div> 

            <div class="mt-4">
              <label class="text-sm">Other Notes</label>
              <vs-textarea label="" class="w-full mt-4" v-model="data_local.other_notes" type="text" v-validate="'required'" name="other_notes" />
              <span class="text-danger text-sm"  v-show="errors.has('other_notes')">{{ errors.first('other_notes') }}</span>
            </div>

            <div class="mt-4">
              <label class="text-sm">Other Comments</label>
              <vs-textarea label="" class="w-full mt-4" v-model="data_local.other_comments" type="text" v-validate="'required'" name="other_comments" />
              <span class="text-danger text-sm"  v-show="errors.has('other_comments')">{{ errors.first('other_comments') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/2 mt-6">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="CalendarIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Request Date Details</span>
        </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">
            <!-- <div class="mt-4" v-if="roleVal == 'admin'">
              <vs-input class="w-full mt-4" label="Issued Date" v-model="data_local.rfp_issue_date" v-validate="'required'" name="rfp_issue_date" disabled/>
              <span class="text-danger text-sm"  v-show="errors.has('rfp_issue_date')">{{ errors.first('rfp_issue_date') }}</span>
            </div>  -->

            <div class="mt-4" v-if="roleVal == 'admin'">
              <label class="text-sm">Send Question Date</label>
              <flat-pickr v-model="data_local.send_question_date" :config="configETA" class="w-full" v-validate="'required'" name="send_question_date" />
              <span class="text-danger text-sm"  v-show="errors.has('send_question_date')">{{ errors.first('send_question_date') }}</span>
            </div> 

            <div class="mt-4" v-if="roleVal == 'admin'">
              <label class="text-sm">Due Date</label>
              <flat-pickr v-model="data_local.rfp_due_date" :config="configETA" class="w-full" v-validate="'required'" name="rfp_due_date" />
              <span class="text-danger text-sm"  v-show="errors.has('rfp_due_date')">{{ errors.first('rfp_due_date') }}</span>
            </div>

            <div class="mt-4" v-if="roleVal == 'admin'">
              <label class="text-sm">Decision Date</label>
              <flat-pickr v-model="data_local.decision_date" :config="configETA" class="w-full" v-validate="'required'" name="decision_date" />
              <span class="text-danger text-sm"  v-show="errors.has('decision_date')">{{ errors.first('decision_date') }}</span>
            </div>

          </div>
        </div>
      </div>    
    </div>

    <!-- Content Row -->
    <div class="vx-row" v-if="false">
      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
        <div class="flex items-end md:mt-4 mt-base">
          <feather-icon icon="FolderIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Files</span>
        </div>

        <!-- Col Content -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <!-- uploading docs -->
            <div class="flex items-start flex-col sm:flex-row">
              <div v-if="files.length > 0" v-for="(item, file) in files">
                <feather-icon icon="XCircleIcon" svgClasses="h-6 w-6" style="top: 12px;left: 82px;color: #ea5455;" class="cursor-pointer" @click="deleteImage(fileKey[file], file)"/>
                <img :src="item" class="mt-4 mr-8 rounded h-24 w-24" />  
              </div>
              <p v-if="files.length ==0" class="mt-2">No files uploaded</p>
            </div>

            <div class="flex items-start flex-col sm:flex-row">
              <!-- <vs-avatar :src="data_localavatar" size="80px" class="mr-4" /> -->
              <!-- uploading docs -->
              <div class="mt-4">            
                <input type="file" multiple="multiple" id="fileD" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">

                <vs-button color="success" class="mr-4" @click="$refs.update_avatar_input.click()">Upload Files</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button color="success" class="ml-auto mt-2" @click="send_rfp" :disabled="this.data_local.is_submitted === 1" v-if="data_local.rfp_type === 2">Send</vs-button>
          <vs-button class="ml-4 mt-2" @click="submit" :disabled="this.data_local.is_submitted === 1 || !validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancel_back">Cancel</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '@/axios'
import common from '@/common'
const jwt = require('jsonwebtoken')
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
const decoded = jwt.verify(localStorage.usertoken, 'secret')  

export default {
  components: {
    vSelect,
    flatPickr,
  },
  data () {
    return {
      configETA: {
        minDate: null,
        maxDate: null, 
        enableTime: false,
        dateFormat: 'F j, Y',
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);
            }
        ]
      },
      configdateFromTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        minTime: "8:00",
        maxTime: "17:00",
        time_24hr: false,
        dateFormat: "h:i K"
      },
      configdateToTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        minTime: "8:00",
        maxTime: "17:00",
        time_24hr: false,
        dateFormat: "h:i K"
      },
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,
        dateFormat: 'F j, Y',        
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);

            }
        ]
      },
      configTodateTimePicker: {
        minDate: null,
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);

            }
        ]
      },

      token: localStorage.usertoken,

      optionMaintenanceType: [],
      optionVendorCategoryMaster: [],
      optionVendor: [],
      optionStaff: [],
      optionUser: [],
      optionBuilding: [],
      optionProperty: [],
      optionUnit: [],
      optionRequestStatus: [],
      optionUrgency: [
        { id:'Low', name: 'Low' },
        { id:'Medium', name: 'Medium' },
        { id:'High', name: 'High' },
      ],

      //portfolio
      data_local: {
        unit_resident_id: null,
        m_request_status_id: 12,
        resolved_date: new Date(),
        building_id: null,
        location: '',
        maintenance_type_id: 0,
        urgency: 'Low',
        title: '',
        description: '',
        image_filename: '',
        m_type_other_value: '',
        assigned_to: null,
        assigned_to_type: 1,
        rfp_type: 0,
        vendor_category_id: 0,
        user_id: null,
        is_seen: 0,
        property_id: null,
        unit_id: null,
        start_time: null,
        end_time: null,
        start_date: null,
        end_date: null,
        eta_dt: null,
        notes: '',
        request_no: null,
        overview: '',
        scope: '',
        request_to: null,
        vendor_email: '',
        direction: '',
        issued_by_id: null,
        rfp_issue_date: null,
        send_question_date: null,
        rfp_due_date: null,
        decision_date: null,
        questions_to_vendor: [],
        qoutation: [],
        availability: '',
        other_comments: '',
        is_submitted: 0,
        rfp_recipients: [],
        other_notes: '',
        maintenance_request_dts: [],
        createdAt: new Date(),
        updatedAt: new Date(),  
      },

      qs: [],
      qts: [],
      // uploading docs
      files: [],
      rawFiles: [],
      resDataLocal: [],
      resUp: [],
      fileKey: [],
      filesDel: [],

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ],

      optionType: [
        { id: 1, name: 'Work Order', val: 'work-order'},
        { id: 2, name: 'Proposal', val: 'proposal'},
        { id: 3, name: 'Information', val: 'information'}
      ],
    }
  },
  computed: {
    roleVal() {
      const userAllData = JSON.parse(localStorage.userAllData)
      
      return userAllData.user_role.val
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    deleteDt(k) {      
      this.$delete(this.data_local.maintenance_request_dts, k)

      this.$vs.notify({
        color: 'success',
        title: 'Deleting Data',
        text: 'File deleted'
      })
    },
    addDt() {
      var newDt = {
        createdAt: null,
        deletedAt: null,
        end_time: null,
        maintenance_request_id: this.data_local.id,
        start_date: null,
        start_time: null,
        updatedAt: null
      }
      this.data_local.maintenance_request_dts.push(newDt)      
    },
    deleteQ(k) {
      this.$delete(this.qs, k)
      this.$vs.notify({
        color: 'success',
        title: 'Deleting Data',
        text: 'File deleted'
      })
    },
    addQ() {
      let q = {
        question: null,
        response: null
      }

      this.qs.push(q)
    },
    deleteQT(k) {
      this.$delete(this.qts, k)
      this.$vs.notify({
        color: 'success',
        title: 'Deleting Data',
        text: 'File deleted'
      })
    },
    addQT() {
      let q = {
        description: null,
        quantity: null,
        sub_amount: null,
        total_amount: null
      }

      this.qts.push(q)
    },
    onFromTimeChange(selectedTime, timeStr, instance) {
      console.log('selectedTime ', selectedTime)
      console.log('timeStr ', timeStr)
      console.log('instance ', instance)
      console.log('timeStr convertT ', common.convertT(timeStr, '2021-01-01') )
      
      this.$set(this.configdateToTimePicker, 'minTime', common.convertT(timeStr, '2021-01-01') );     
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
    },
    clearSelectAssign() {
      console.log('clearSelectAssign')
      this.data_local.rfp_recipients = ''
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    deleteImage(f, k) {
      // document.getElementById(f).style.display = 'none';
      console.log('f ', f)
      console.log('k ', k)
      this.$delete(this.fileKey, k)
      this.$delete(this.files, k)
      this.$delete(this.rawFiles, k)
      this.filesDel.push(f)

      this.$vs.notify({
        color: 'success',
        title: 'Deleting Data',
        text: 'File deleted'
      })
    },
    submit(loc) {
      this.$validator.validateAll()
      .then(result => {
        if(result) {
          this.save_changes(loc)
        }
      })
    },
    send_rfp() {
      this.data_local.issued_by_id = decoded.id
      this.data_local.rfp_issue_date = new Date()
      this.data_local.is_submitted = 1
      this.data_local.m_request_status_id = 15

      this.save_changes()
    },
    save_changes (loc) {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      const editId = -1      
      this.data_local.property_ref = localStorage.selectedParentOrgRef
      this.data_local.questions_to_vendor = this.qs
      this.data_local.qoutation = this.qts      

      new Promise(async(resolve, reject)  => {
        try {    
            await axios.post(`/order/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {    
              if(res['data'] != 'access_denied' && res['data'] != '') {

                //uploading docs
                if(res['data']['message'] == 'success') {
                  //uploading docs
                  this.resDataLocal = res['data']['result']

                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully saved'
                  })

                  if (loc=='a') {
                    setTimeout(() => {
                      window.location.href = "/orders/new";
                    },500)
                  } else {
                    // this.$router.push({name:'app-order-list'})
                  }

                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                // this.$router.push({name:'app-order-list'})
              }

            })
            .catch(err => {
              console.log('err ', err)
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            })

            // uploading docs
            await axios.post(`/docs/table/save`, {
              rawFiles: this.rawFiles,
              token: this.token,
              id: this.resDataLocal.id,
              path: `docs/maintenance-order/gallery/${this.resDataLocal.id}`,
              folderId: 20
            })

            this.$router.push({name:'app-order-list'})
        } catch(err) {
          console.log('err ', err)
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      //portfolio
      this.data_local['name'] = ''
      this.data_local['unit_resident_id'] = ''
      this.data_local['m_request_status_id'] = ''      
      this.data_local['phone'] = ''
      this.data_local['resolved_date'] = ''
      this.data_local['building_id'] = ''
      this.data_local['location'] = ''
      this.data_local['maintenance_type_id'] = ''
      this.data_local['urgency'] = ''
      this.data_local['description'] = ''
      this.data_local['m_type_other_value'] = ''
      this.data_local['assigned_to'] = ''
      this.data_local['rfp_type'] = ''
      this.data_local['vendor_category_id'] = ''
      this.data_local['user_id'] = ''
      this.data_local['is_seen'] = ''
      this.data_local['property_id'] = ''
      this.data_local['unit_id'] = ''
      this.files = []
      this.rawFiles = []

      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    cancel_back () {
      this.$router.go(-1)
    },
    //uploading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    //uploading docs
    async update_avatar () {
      this.$vs.loading()
      var formdata = new FormData();
      $.each($('#fileD')[0].files, function(i, file) {
        formdata.append('fileD_'+i, file);
      });
      formdata.append('token', this.token)

      this.resUp = await axios.post(`/docs/upload`,  
        formdata, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
      )

      if (this.resUp.data.errors !== undefined) {  
        this.$vs.loading.close()
        return false
      }

      for (const [key, value] of Object.entries(this.resUp.data.rawD)) {
        var imgB64 = this._arrayBufferToBase64( value.data.data )
        var imgAsc = imgB64.toString('ascii')
        this.files.push("data:image/png;base64, " + imgAsc)
      }

      if (this.resUp.data.uploadedD.length > 1) {
        for (const [key, value] of Object.entries(this.resUp.data.uploadedD)) {
          this.rawFiles.push(value)
        }
      } else {
        this.rawFiles[0] = this.resUp.data.uploadedD
      }

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
    loadMaintenanceType () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/maintenanceType/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res maintenanceType ', res)
        this.optionMaintenanceType = res
      })
    },
    loadVendorCategoryMaster () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/vendorCategoryMaster/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadVendorCategoryMaster ', res)
        this.optionVendorCategoryMaster = res
      })
    },
    loadVendor () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/vendor/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadVendor ', res)
        this.optionVendor = res
      })
    },
    loadStaff () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/staff/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadStaff ', res)
        this.optionStaff = res
      })
    },    
    loadUser () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/user/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadUser ', res)
        this.optionUser = res
      })
    },
    loadBuilding () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/building/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadBuilding ', res)
        this.optionBuilding = res
      })
    },
    loadProperty () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/property/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadProperty ', res)
        this.optionProperty = res
      })
    },
    loadUnit () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/unit/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadUnit ', res)
        this.optionUnit = res
      })
    },
    loadRequestStatus () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/requestStatus/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadRequestStatus ', res)
        this.optionRequestStatus = res
      })
    }
  },
  created () {
    this.loadMaintenanceType()
    this.loadVendorCategoryMaster()
    this.loadVendor()
    this.loadUser()
    this.loadBuilding()
    this.loadProperty()
    this.loadUnit()
    this.loadRequestStatus()
    this.loadStaff()

    this.data_local.request_no = "MR-" + common.formatDate5(new Date())
    this.data_local.user_id = decoded.id
  }  
}
</script>
